import { IForecastStaff } from '@/coreDomainsModule/entities/forecast';

/**
 * TODO: 仮
 */
export class ForecastStaffFactory {
  /**
   * TODO: 仮
   * @param initialData - 初期値
   */
  public static create(initialData: Partial<IForecastStaff> = {}): IForecastStaff {
    const forecastStaff: IForecastStaff = {
      forecastStaffId: initialData.forecastStaffId ?? '',
      forecastStaffName: initialData.forecastStaffName ?? '',
      recoveredForecastCount: initialData.recoveredForecastCount ?? 0,
      totalForecastCount: initialData.totalForecastCount ?? 0,
      latestUpdateAt: initialData.latestUpdateAt ?? { year: -1, month: -1, day: -1 },
    };
    return forecastStaff;
  }

  /**
   * TODO: 仮
   * @param initialData - 初期値
   */
  public static createWithRequired(initialData: Partial<IForecastStaff> = {}): IForecastStaff {
    const forecastStaff: Required<IForecastStaff> = {
      forecastStaffId: initialData.forecastStaffId ?? '',
      forecastStaffName: initialData.forecastStaffName ?? '',
      recoveredForecastCount: initialData.recoveredForecastCount ?? 0,
      totalForecastCount: initialData.totalForecastCount ?? 0,
      latestUpdateAt: initialData.latestUpdateAt ?? { year: -1, month: -1, day: -1 },
    };
    return forecastStaff;
  }
}
